import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Popover from 'react-bootstrap/lib/Popover';
import Overlay from 'react-bootstrap/lib/Overlay';

const CustomPopover = (props) => {
  const {
    id,
    arrowLeft = 0,
    arrowTop = 0,
    left = 0,
    top = 0,
    arrowOffsetLeft,
    arrowOffsetTop,
    className,
    placement,
    children,
    positionTop,
    positionLeft
  } = props;

  return (
    <Popover
      id={id}
      placement={placement}
      className={className}
      arrowOffsetLeft={arrowLeft || arrowOffsetLeft}
      arrowOffsetTop={arrowTop || arrowOffsetTop}
      positionLeft={ left + positionLeft }
      positionTop={ top + positionTop }
    >
      {children}
    </Popover>
  );
};

CustomPopover.propTypes = {
  id: PropTypes.string.isRequired,
  placement: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
    PropTypes.array
  ]),
  arrowLeft: PropTypes.number,
  arrowTop: PropTypes.number,
  left: PropTypes.number,
  top: PropTypes.number,
  arrowOffsetLeft: PropTypes.string,
  arrowOffsetTop: PropTypes.string,
  positionLeft: PropTypes.number,
  positionTop: PropTypes.number,
  className: PropTypes.string
};


export class Tooltip extends Component {
  constructor (props) {
    super(props);
    this.state = {
      show: false
    };
    this.toggle = this.toggle.bind(this);
    this.setTooltipState = this.setTooltipState.bind(this);
    this.closeX = this.closeX.bind(this);
    this.defaultTooltipAnchor = this.defaultTooltipAnchor.bind(this);
    this.anchorType = this.anchorType.bind(this);
    this.externallyOpenTooltip = this.externallyOpenTooltip.bind(this);
    this.externallyCloseTooltip = this.externallyCloseTooltip.bind(this);
  }

  componentDidMount () {
    const { openOnRender, managedByParentVal, delayRenderBy = 0 } = this.props;
    const hasManagedByParentVal = this.props.hasOwnProperty('managedByParentVal');

    if (openOnRender) {
      setTimeout(() => {
        this.setState({ show: true });
      }, delayRenderBy * 1000);
    }
    if (hasManagedByParentVal && _.isBoolean(managedByParentVal)) {
      this.setState({ show: managedByParentVal });
    }
  }

  componentWillReceiveProps (nextProps) {
    const { managedByParentVal: currVal } = this.props;
    const { managedByParentVal: nextVal } = nextProps;
    const hasManagedByParentVal = this.props.hasOwnProperty('managedByParentVal');
    if (hasManagedByParentVal && _.isBoolean(nextVal) && (currVal !== nextVal)) {
      this.setState({ show: nextVal });
    }
  }

  setTooltipState (show) {
    this.setState({ show });
  }

  toggle (e) {
    if (e) e.preventDefault();

    const { show } = this.state;
    const { toggleCB } = this.props;
    this.setState({ show: !show });
    if (toggleCB) {
      toggleCB();
    }
  }

  closeX () {
    const { closeXCB, toggleShowDate } = this.props;
    this.setState({ show: false });
    if (closeXCB) {
      closeXCB();
    }

    if (toggleShowDate) {
      toggleShowDate();
    }
  }

  externallyCloseTooltip () {
    // To call this function you need to define the tooltip refs
    // from the parent component and initiating the function
    // example: this.tooltipCompnent.externallyCloseTooltip();
    this.setState({ show: false });
  }

  externallyOpenTooltip () {
    // To call this function you need to define the tooltip refs
    // from the parent component and initiating the function
    // example: this.tooltipCompnent.externallyOpenTooltip();
    this.setState({ show: true });
  }

  defaultTooltipAnchor () {
    return (
      <button type="button" ref={ (node) => { this.buttonNode = node; }} onClick={this.toggle} className="btn link-gray remove-click-styling no-gutter-all">
        <i className="ico ico-md icon-question" />
      </button>
    );
  }

  anchorType ({ anchorType, customAnchor, anchorClickCB }) {
    const { show } = this.state;
    const anchorTypes = {
      default: this.defaultTooltipAnchor(),
      custom: customAnchor ? React.cloneElement(customAnchor, {
        ref: (node) => { this.buttonNode = node; },
        onClick: anchorClickCB ? anchorClickCB.bind(null, {
          open: show,
          showTooltip: this.setTooltipState
        }) : () => {}
      }) : null
    };
    return anchorTypes[anchorType] || null;
  }

  render () {
    const { show } = this.state;
    const {
      // tooltip styling
      tooltipClass, placement, arrowPlacement, id, animation = true,
      // functionality
      showX, openCB, exitCB, anchorClickCB, hideOnClickAnywhere,
      // view
      anchorType, customAnchor, parentNode, children, shouldUpdatePosition, isBookingForm, showDate
    } = this.props;

    const anchor = this.anchorType({ anchorType, customAnchor, anchorClickCB });
    return (
      <div className="tooltip-v2-container" style={{ position: 'relative' }}>
        { anchor }
        <Overlay
          show={isBookingForm ? showDate : show}
          rootClose={hideOnClickAnywhere}
          onHide={this.closeX}
          container={parentNode || this}
          placement={placement}
          onEnter={openCB}
          onExited={exitCB}
          target={this.buttonNode}
          animation={animation}
          shouldUpdatePosition={shouldUpdatePosition}
        >
          <CustomPopover
            id={id}
            placement={placement}
            className={tooltipClass}
            {...arrowPlacement}
          >
            {
              showX &&
                <i
                  className="ico icon-no"
                  style={{ cursor: 'pointer' }}
                  onClick={ this.closeX }
                  role="button"
                  tabIndex="0"
                />
            }
            { children }
          </CustomPopover>
        </Overlay>
      </div>
    );
  }
}

Tooltip.propTypes = {
  // Behavior Customizations:
  hideOnClickAnywhere: PropTypes.bool.isRequired,
  animation: PropTypes.bool, // false is default, true makes it fade in
  openOnRender: PropTypes.bool,
  delayRenderBy: PropTypes.number,

  // Specify your tooltip's anchor here:
  anchorType: PropTypes.oneOf(['default', 'custom', 'none']), // Required
  customAnchor: PropTypes.object,
  anchorClickCB: PropTypes.func,
  /* customAnchors NEED anchorClickCB.
   It will receive an object called: tooltipHelpers =
   { open: this.state.show,
     showTooltip: this.setTooltipState };
   This will allow you to manually handle tooltip state
   while running your custom anchor's behavior.
  */

  // Other Behaviors & Callbacks
  toggleShowDate: PropTypes.func,
  showX: PropTypes.bool, // add this if you want the X to close out tooltip
  closeXCB: PropTypes.func,

  openCB: PropTypes.func, // CB when tooltip opens, optional
  exitCB: PropTypes.func,
  toggleCB: PropTypes.func, // CB when tooltip uses default anchor

  // if you want to manage tooltip state using its parent, use these two:
  managedByParentVal: PropTypes.bool,

  // Tooltip Styling Customizations
  placement: PropTypes.oneOf(['top', 'bottom', 'left', 'right']), // Required
  arrowPlacement: PropTypes.shape({
    arrowLeft: PropTypes.number,
    arrowTop: PropTypes.number,
    left: PropTypes.number,
    top: PropTypes.number,
    arrowOffsetLeft: PropTypes.string,
    arrowOffsetTop: PropTypes.string
  }),
  id: PropTypes.string,
  tooltipClass: PropTypes.string,

  // deep customization:
  parentNode: PropTypes.object, // explicitly define the tooltip's parent.

  // internal prop only: holds the nested elements added inside your tooltip's usage
  children: PropTypes.object,
  shouldUpdatePosition: PropTypes.bool,
  isBookingForm: PropTypes.bool,
  showDate: PropTypes.bool
};
